/**
 * Labstep
 *
 * @module components/Chemical/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { ChemicalActionDeleteProps } from './types';

export const ChemicalActionDelete: React.FC<
  ChemicalActionDeleteProps
> = ({ chemical, ...rest }) => (
  <EntityActionDelete {...rest} entity={chemical} isRemoveAction />
);
